import { render, staticRenderFns } from "./CombosGeneradosImportAsignacionErrorNivel.vue?vue&type=template&id=f2cd2164"
import script from "./CombosGeneradosImportAsignacionErrorNivel.vue?vue&type=script&lang=js"
export * from "./CombosGeneradosImportAsignacionErrorNivel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports